import { generatedKeys } from '../queryKeysFactory';
import { brandingConfig } from '@app/Services/Branding';
import { BrandingConfig } from '@app/Services/Branding/types';
import { enableDevToolsForBranding } from '@app/Services/Branding/utils';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { BRANDING_STORAGE_KEY } from './constants';

/**
 * This hook is used to fetch the branding config from the server and save it to the local storage.
 * The config is saved to the local storage to avoid unnecessary re-fetching of the config which saves inital loading time.
 */

export const useBrandingConfig = () => {
	const initialData = localStorage.getItem(BRANDING_STORAGE_KEY);
	const query = useQuery({
		queryFn: brandingConfig,
		queryKey: generatedKeys.acquirer.brandingConfig?.({}) as string[],
		/**
		 * If the branding dev tools are enabled, we don't want to use the placeholder data from the local storage.
		 * This is because the placeholder data is not the latest data from the server.
		 * We want to fetch the latest data from the server in this case.
		 */
		placeholderData: enableDevToolsForBranding()
			? undefined
			: initialData
			? (JSON.parse(initialData) as BrandingConfig)
			: undefined,
		staleTime: 60 * 60 * 1000, // 1 hour
	});

	useEffect(() => {
		if (query.data) {
			localStorage.setItem(BRANDING_STORAGE_KEY, JSON.stringify(query.data));
		}
	}, [query.data]);

	return query;
};
